import React from "react";
import { useStore } from "@/store/store";
import { UnauthorizedModuleFallback } from "./UnauthorizedModuleFallback";
import { isAdminLike } from "@/utils/routingUtils";

type TFeatureFlagGuardProps = {
  requiredFlags: string[];
  children: React.ReactNode;
};

const FeatureFlagGuard = ({
  requiredFlags,
  children,
}: TFeatureFlagGuardProps) => {
  const featureFlags = useStore((state) => state.featureShowHideFlag);
  const user = useStore((state) => state.user);
  const isAdmin = isAdminLike(user);
  if (isAdmin) return <>{children}</>;
  // Match routesFeatureFlagCheck: allow through until flags are loaded.
  if (!Array.isArray(featureFlags) || featureFlags.length === 0) {
    return <>{children}</>;
  }

  const isAuthorized = requiredFlags.some((slug) =>
    featureFlags.includes(slug),
  );

  if (!isAuthorized) {
    return <UnauthorizedModuleFallback />;
  }

  return <>{children}</>;
};

export default FeatureFlagGuard;
